import { apiGateway } from "@/_old/services/api-gateway";
import { FeedbackParams, FeedbackResponse } from "../types/feedback";

const sendFeedback = async (
  params: FeedbackParams,
  signal?: AbortSignal,
): Promise<FeedbackResponse> => {
  const { data } = await apiGateway.post<FeedbackResponse>(
    "/feedback",
    params,
    {
      signal,
    },
  );

  return data;
};

export { sendFeedback };
